import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import TruncateMarkup from 'react-truncate-markup';
import { propStr } from '../../../../../../helpers/custom-prop-types';
/**
 * スライド受領のメッセージ内容を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchReceiveItemContent = (props) => {
    const { className, content } = props;
    if (!content) {
        return null;
    }
    return (_jsx(TruncateMarkup, Object.assign({ lines: 2 }, { children: _jsx("div", Object.assign({ className: clsx('slide_search_receive_item_content', className) }, { children: content })) })));
};
SlideSearchReceiveItemContent.propTypes = {
    className: propStr(),
    content: propStr().isRequired,
};
SlideSearchReceiveItemContent.defaultProps = {
    className: '',
};
export default SlideSearchReceiveItemContent;
